import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Alert } from "react-bootstrap";
import { Turnstile } from "@marsidev/react-turnstile";
import type { TurnstileInstance } from "@marsidev/react-turnstile";

import supabase from "../utils/Supabase";
import { showToast } from "../utils/Toasts";
import { validateEmail } from "../utils/Text";

import { LoadingText } from "../components/LoadingText";

import logo from "../img/sh-logo_site.png";

const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY ?? '';
const TURNSTILE_ENABLED = !!TURNSTILE_SITE_KEY;

function ResetPasword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [captchaToken, setCaptchaToken] = useState<string | null>(TURNSTILE_ENABLED ? null : "bypass");
  const turnstileRef = useRef<TurnstileInstance>(null);
  const navigate = useNavigate();

  return (
    <>
      <main className="d-flex" style={{ flex: "max-content" }}>
        <div className="m-auto">
          <img
            className="p-10 m-8 hivelogo"
            src={logo}
            alt="Script Hive logo"
            width={90}
          ></img>

          <p className="text-center my-3 ">
            Enter your email address to receive a password reset link.
          </p>

          {error && (<Alert
            variant="danger"
            className="mt-3"
          >
            {error}
          </Alert>)}

          <div className="d-flex flex-column form">
            <input
              className="mt-3 form-control"
              id="PasswordResetEmail"
              placeholder="example@email.com"
              onChange={function (e) {
                setError("");
                setEmail(e.target.value);
              }}
            />
            
            {TURNSTILE_ENABLED && (
              <Turnstile
                ref={turnstileRef}
                siteKey={TURNSTILE_SITE_KEY}
                onSuccess={(token) => setCaptchaToken(token)}
                onExpire={() => setCaptchaToken(null)}
                onError={() => {
                  setCaptchaToken(null);
                  turnstileRef.current?.reset();
                }}
                className="mt-3"
              />
            )}

            <Button
              className="form-control btn-warning"
              id="ResetPasswordBtn"
              disabled={TURNSTILE_ENABLED && captchaToken === null}
              onClick={async () => {
                setLoading(true);
                if (!validateEmail(email)) {
                  setError("Please enter a valid email address.");
                  setLoading(false);
                  return;
                }
                const { data, error } = await supabase.auth.resetPasswordForEmail(
                  email, {
                    redirectTo: `${window.location.origin}/newPassword`,
                    captchaToken: TURNSTILE_ENABLED ? (captchaToken ?? undefined) : undefined,
                  }
                );

                if (data && !error) {
                  showToast("success", "Please check your email for a Password Reset notification!");
                  navigate("/");
                } else if (error) {
                  setError(error.message);
                  setLoading(false);
                  turnstileRef.current?.reset();
                  setCaptchaToken(null);
                }
              }}
            >
              {loading && (<LoadingText text="" className="mb-0" />)}
              Reset Your Password
            </Button>
          </div>
        </div>
      </main>
    </>
  );
}

export default ResetPasword;
